var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-key": "authorityId",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "公告ID",
      prop: "id",
      width: "80"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "渠道",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v(" " + _vm._s(_vm.getChannelLable(row)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "公告状态",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [_c("span", {
          style: {
            color: row.status ? "green" : "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.status[row.status]) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "是否弹出",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.is_pop ? "弹出" : "不弹出") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "公告类型",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.type[scope.row.type]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "公告标题",
      prop: "title"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "时效状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var row = _ref3.row;
        return [_c("span", {
          style: {
            color: _vm.getTimeStatusColor(row)
          }
        }, [_vm._v(" " + _vm._s(_vm.getTimeStatusLabel(row)) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "开始时间",
      prop: "start_time",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "结束时间",
      prop: "end_time",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            icon: "el-icon-edit",
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.checkBtn(scope.row);
            }
          }
        }, [_vm._v(" 查看 ")]), _c("el-button", {
          attrs: {
            icon: "el-icon-edit",
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.editBtn(scope.row);
            }
          }
        }, [_vm._v(" 编辑 ")])];
      }
    }])
  })], 1), _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _c("div", [_vm.dialogFormVisible ? _c("el-dialog", {
    attrs: {
      title: "查看详细公告信息",
      visible: _vm.dialogFormVisible,
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("show-notice-msg", {
    attrs: {
      infoMsg: _vm.infoMsg
    }
  })], 1) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };